import { ProviderProgramTaxonomy } from '../providers/Providers'

export enum ProgramNames {
  SingleSessionCoaching = 'SingleSessionCoaching',
  BlendedCareTherapy = 'BlendedCareTherapy',
  Coaching = 'Coaching',
  CoachingForParents = 'CoachingForParents',
  ManagerCoaching = 'ManagerCoaching',
  MedicationManagement = 'MedicationManagement',
  AlcoholUseDisorderTherapy = 'AlcoholUseDisorderTherapy',
  ClinicalLeaveEvaluation = 'ClinicalLeaveEvaluation',
  TeensTherapy = 'TeensTherapy',
  DialecticalBehaviorTherapy = 'DialecticalBehaviorTherapy',
  DialecticalBehaviorTherapyTeens = 'DialecticalBehaviorTherapyTeens',
  NeurodiversitySkillsCoaching = 'NeurodiversitySkillsCoaching',
  CaregiverTrainingForNeuro = 'CaregiverTrainingForNeuro',
  NeuroPsychologicalEvaluations = 'NeuroPsychologicalEvaluations',
  BehavioralHealthUrgentCare = 'BehavioralHealthUrgentCare',
  PediatricVirtualIntensiveOutpatientProgram = 'PediatricVirtualIntensiveOutpatientProgram',
  DirectAccessCouplesTherapy = 'DirectAccessCouplesTherapy',
  DirectAccessIndividualTherapy = 'DirectAccessIndividualTherapy',
  DirectAccessFamilyTherapy = 'DirectAccessFamilyTherapy',
  DirectAccessIndividualAdolescentTherapy = 'DirectAccessIndividualAdolescentTherapy',
  DirectAccessIndividualChildTherapy = 'DirectAccessIndividualChildTherapy',
  PerformanceCoaching = 'PerformanceCoaching',
  // Non LT programs
  DIRECT_ACCESS_MEDS = 'DIRECT_ACCESS_MEDS',
  SELF_CARE_APPS = 'SELF_CARE_APPS',
  DIRECT_ACCESS_THERAPY = 'DIRECT_ACCESS_THERAPY',
  ICASTherapy = 'ICASTherapy',
}

// [CPR-2417] TODO: Define performance coaching program
export type LTProgramName = Exclude<
  ProgramNames,
  | 'DIRECT_ACCESS_MEDS'
  | 'SELF_CARE_APPS'
  | 'DIRECT_ACCESS_THERAPY'
  | 'ICASTherapy'
  | 'PerformanceCoaching'
  | 'NeuroPsychologicalEvaluations'
  | 'BehavioralHealthUrgentCare'
  | 'PediatricVirtualIntensiveOutpatientProgram'
>

export interface Program {
  appointment_change_window_hours: number
  appt_follow_up_ai_prompts?: string[]
  appt_initial_ai_prompts?: string[]
  appt_initial_mins: number
  appt_recurring_mins: number
  assessment_sets?: string[]
  compatible_programs: CompatibleProgram[]
  create_date: string
  curricula: unknown
  default_grace_period_hours: number
  employment_week_work_hours?: {
    [key: string]: number
  }
  gad_threshold?: number
  id: string
  late_cancel_charge_initial: number
  late_cancel_charge_recurring: number
  name: string
  phq_threshold?: number
  program_taxonomy: ProviderProgramTaxonomy[]
  provider_modality: string
  session_type_initial: string
  session_type_recurring: string
  utilization_target_percent?: {
    [key: string]: number
  }
  utilization_target_plus_percent?: {
    [key: string]: number
  }
}

interface CompatibleProgram {
  compatible_program_id: string
  id: string
  program_id: string
}
